"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("../../utils/classnames"));
require("./NewTab.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var NewTab = function NewTab(_ref) {
  var index = _ref.index,
    active = _ref.active,
    disabled = _ref.disabled,
    unread = _ref.unread,
    onClick = _ref.onClick,
    children = _ref.children,
    title = _ref.title,
    collapsed = _ref.collapsed;
  var classes = (0, _classnames["default"])({
    disabled: disabled,
    active: !disabled && active
    // warning: !disabled && !active && warning
  });

  return /*#__PURE__*/_react["default"].createElement("div", {
    tabIndex: index,
    className: 'gcl-um ' + classes + (collapsed ? ' collapsed' : ''),
    onClick: onClick
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'gcl-um-icon ' + classes
  }, children), /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-um-title"
  }, title), unread > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: 'gcl-um-notification '
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-um-notification-icon"
  }, (unread > 99 ? '+' : '') + Math.min(unread, 99))));
};
NewTab.propTypes = {
  index: _propTypes["default"].number.isRequired,
  active: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  unread: _propTypes["default"].number,
  warning: _propTypes["default"].bool,
  onClick: _propTypes["default"].func.isRequired,
  title: _propTypes["default"].string
};
NewTab.defaultProps = {
  active: false,
  disabled: false,
  unread: 0,
  warning: false,
  title: ''
};
var _default = exports["default"] = NewTab;


//////////////////
// WEBPACK FOOTER
// ./~/cw-unified-inbox/dist/components/Tab/NewTab.js
// module id = 1426
// module chunks = 0